<acabim-datatable [dataSources]="[this]" [hasDetailView]="true"></acabim-datatable>

<acabim-modal
    (status)="changeModalStatus($event)"
    [display]="showDetails"
    [title]="'User details'"
    [footer]="false"
    width="80vw"
    fixHeight="80vh"
    [showTooltip]="false">
    <acabim-admin-edit-organisation-user [user]="detailData" (userDetailsChanged)="onUserDetailsChanged()"></acabim-admin-edit-organisation-user>
</acabim-modal>
